<template>
  <div class="h-full flex flex-col -m-base">
    <div>
      <slot name="banner"></slot>
      <div class="h-publicPageHeaderMobile md:h-publicPageHeader bg-primary flex items-center justify-center md:justify-between">
        <img class="w-publicPageLogoMobile md:w-publicPageLogo md:ml-xl"
             :alt="$t('functional.signableLogo')"
             src="@/assets/signable_white_raster.png" />
        <slot name="header-right"></slot>
      </div>
    </div>
    <div class="flex m-base xs:m-none xs:grid xs:grid-cols-publicPageMobile sm:grid-cols-publicPageTablet md:grid-cols-publicPage h-full bg-offWhite">
      <div class="col-start-1 col-end-2">
        <div class="bg-squiggle1 bg-no-repeat w-leftSquiggle h-leftSquiggle absolute -left-base bottom-leftSquiggleHeight -rotate-12"></div>
      </div>
      <div class="z-10 w-full col-start-2 col-end-3 flex flex-col items-center m-auto">
        <slot name="content"></slot>
      </div>
      <div class="col-start-3 col-end-4">
        <div class="bg-squiggle2 bg-no-repeat w-rightSquiggle h-rightSquiggle absolute -right-ml top-20"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PublicPageTemplate',
};
</script>
